import React from 'react';
import { useTranslation } from 'react-i18next';
import * as LucideIcons from 'lucide-react';
import CommentSection from './CommentSection';

const CommentModal = ({ post, onClose, contentType, nexusId }) => {
    const { t } = useTranslation();

    if (!post) return null;

    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center z-50" onClick={onClose}>
            <div className="bg-gray-900/80 p-6 rounded-lg shadow-glow max-w-2xl w-full border border-purple-500/50 flex flex-col" style={{ maxHeight: '80vh' }} onClick={e => e.stopPropagation()}>
                <div className="flex justify-between items-center mb-4 flex-shrink-0">
                    <h2 className="text-2xl font-bold text-white font-playfair">{t('commentModal.title')}</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-white">
                        <LucideIcons.X size={24} />
                    </button>
                </div>
                <div className="flex-grow overflow-y-auto custom-scrollbar pr-2">
                    <CommentSection 
                        entryId={post.id} 
                        contentType={contentType || post.contentType} 
                        nexusId={nexusId || post.nexusId} 
                    />
                </div>
            </div>
        </div>
    );
};

export default CommentModal;